import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { OneSetCard } from "./OneSetCard";
import { useRecentSets } from "@/hooks/useRecentSets";
import { CustomLoadingError } from "@/components/ui/CustomLoadingError";
import { CustomLoader } from "@/components/ui/CustomLoader";

export function RecentTrackedSets() {
  const navigate = useNavigate();

  const { data: todaySets, isLoading, isError } = useRecentSets();

  if (isLoading) {
    return <CustomLoader size="small" />;
  }

  if (isError) {
    return <CustomLoadingError />;
  }

  if (todaySets && todaySets.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-4xl shadow-md py-10 px-6 max-w-xs w-full">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-base font-semibold text-tx-dark">Recent</h2>
        <Button variant="link" size="sm" onClick={() => navigate("/workouts")}>
          See All
        </Button>
      </div>

      {/* Set Items */}
      {todaySets && todaySets.length > 0 && (
        <div className="space-y-3">
          {todaySets.map((set) => (
            <OneSetCard key={set.nano_id} set={set} />
          ))}
        </div>
      )}
    </div>
  );
}
